import { useRef, useState } from "react";
import { toast } from "sonner";
import api from "../../lib/api";
import { Modal } from "../Modal";
import { SignaturePad } from "../SignaturePad";
import { fmtKc } from "../../lib/format";

const inputCls = "w-full px-3 py-2 border border-slate-300 bg-white text-sm focus:outline-none focus:ring-2 focus:ring-orange-600 rounded-sm";

// Podpis klienta prstem na místě (technik / vlastník drží telefon nebo tablet).
export function AddendumSignModal({ jobId, addendum, onClose, onSigned }) {
    const pad = useRef(null);
    const [name, setName] = useState(addendum.client_name || "");
    const [busy, setBusy] = useState(false);
    const sign = async () => {
        if (pad.current.isEmpty()) { toast.error("Klient se musí podepsat"); return; }
        setBusy(true);
        try { const { data } = await api.post(`/jobs/${jobId}/addendums/${addendum.id}/sign`, { signature_data_url: pad.current.toDataURL(), signer_name: name }); toast.success("Dodatek podepsán"); onSigned(data); }
        catch (e) { toast.error(e.response?.data?.detail || "Podpis se nepodařilo uložit"); }
        setBusy(false);
    };
    return (
        <Modal title={`Podpis dodatku ${addendum.number}`} subtitle={`${addendum.title || "Vícepráce / méněpráce"} · ${fmtKc(addendum.subtotal)} bez DPH`} onClose={onClose} testid="addendum-sign" size="max-w-xl"
               footer={<><button onClick={onClose} className="px-4 py-2.5 text-xs uppercase tracking-wider border border-slate-300 rounded-sm">Zrušit</button><button onClick={sign} disabled={busy} className="px-5 py-2.5 text-xs uppercase tracking-wider font-semibold bg-emerald-600 text-white rounded-sm" data-testid="addendum-sign-submit">Uložit podpis</button></>}>
            <div className="space-y-3">
                <ul className="text-sm border border-slate-200 divide-y">{addendum.items.map((i, k) => <li key={k} className="flex justify-between px-3 py-1.5"><span>{i.name} <span className="text-slate-500">{i.quantity} {i.unit}</span></span><span className="tabular-data">{fmtKc(i.total)}</span></li>)}</ul>
                <div><label className="label-eyebrow block mb-1.5">Jméno podepisující osoby</label><input value={name} onChange={(e) => setName(e.target.value)} className={inputCls} data-testid="addendum-signer-name" /></div>
                <SignaturePad ref={pad} testid="addendum-signature-pad" />
                <p className="text-[11px] text-slate-500">Podpisem objednatel potvrzuje objednávku uvedených prací a změnu ceny díla. Uloží se datum, čas a IP adresa.</p>
            </div>
        </Modal>
    );
}
